import { render, staticRenderFns } from "./MasonryObras.vue?vue&type=template&id=d53f8edc&scoped=true"
import script from "./MasonryObras.vue?vue&type=script&lang=js"
export * from "./MasonryObras.vue?vue&type=script&lang=js"
import style0 from "./MasonryObras.vue?vue&type=style&index=0&id=d53f8edc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d53f8edc",
  null
  
)

export default component.exports